import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';

import PlainModal from '@whelk/components/src/Base/PlainModal';
import { RootState } from '@whelk/store';
import { setBannedAppealModal } from '@whelk/store/slices/userSlice';
import { Toast } from '@whelk/components';
import { postBannedAppeal } from '@whelk/services/src/user';

import AppealContent from './components/AppealContent';
import BannedContent from './components/BannedContent';
import { isApiError } from '@whelk/services/src/common';

const UserBannedAppealModal = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  // 获取封禁信息 包含是否显示弹窗，以及弹窗的封禁截止文案
  const bannedAppealModal = useSelector((state: RootState) => state?.user?.bannedAppealModal);
  // 当前是否为申诉表单
  const [isAppealForm, setIsAppealForm] = useState(false);

  // 关闭弹窗
  const onClose = () => {
    dispatch(setBannedAppealModal({ show: false, message: '' }));
    setIsAppealForm(false);
  };

  const onAppeal = async (params?: { email: string; successCb: () => void }) => {
    // 调用申诉接口，传入email，返回状态信息
    try {
      const statusInfo = await postBannedAppeal(
        params?.email ? { email: params.email } : undefined,
      );
      // 根据code提示不同文案
      if (statusInfo.code === 0) {
        Toast.success(t('user_ban_appeal_submit'));
        params?.successCb();
        onClose();
      } else if (statusInfo.code === 23) {
        // 之前申诉过，提示不同文案
        Toast.warning(statusInfo.message);
        params?.successCb();
        onClose();
      } else {
        Toast.error(statusInfo.message);
      }
    } catch (error) {
      if (isApiError(error)) {
        if (error.code === 23) {
          // 错误码code为23，提示不同文案，并关闭弹窗
          Toast.warning(error.message);
          params?.successCb();
          onClose();
        } else {
          Toast.error(error.message);
        }
      } else {
        Toast.error(t('user_ban_appeal_submit_failed'));
      }
    }
  };

  return (
    <PlainModal
      open={bannedAppealModal.show}
      onClickMask={onClose}
      size='sm'
      title={t('user_ban_appeal_title')}
      onClose={onClose}
    >
      {isAppealForm ? (
        <AppealContent setIsAppealForm={setIsAppealForm} onAppeal={onAppeal} />
      ) : (
        <BannedContent setIsAppealForm={setIsAppealForm} onClose={onClose} onAppeal={onAppeal} />
      )}
    </PlainModal>
  );
};

export { UserBannedAppealModal };
